import { DiscountTypeEnum, MembershipDto, MembershipPublishingStateEnum } from '@sweatpals/shared';
import { CreateEventPriceToMembershipDto } from '../models/dto';
import { EventPriceToMembershipType } from '../constants';

export const extendPriceToMembershipListWithMissingMemberships = (
	existingRelations?: CreateEventPriceToMembershipDto[],
	hostMemberships?: MembershipDto[],
): CreateEventPriceToMembershipDto[] => {
	const filteredHostMemberships = (hostMemberships ?? []).filter(membership => (
		membership.publishingState !== MembershipPublishingStateEnum.Canceled
		|| (!!membership.activeMembersCount && membership.activeMembersCount >= 1)
	));
	const filteredHostMembershipIds = filteredHostMemberships.map(m => m.id);
	const result = structuredClone(
		existingRelations?.filter(em => filteredHostMembershipIds.includes(em.membershipId)) ?? []
	);

	for (const hostMembership of filteredHostMemberships) {
		if (existingRelations?.some(em => em.membershipId === hostMembership.id)) {
			continue;
		}

		result.push({
			type: EventPriceToMembershipType.FullPrice,
			membershipId: hostMembership.id,
			discountType: DiscountTypeEnum.Percentage,
			priceAmount: 100,
		});
	}

	return result;
};
